"use client";

import { type ReactNode } from "react";

import { cn } from "../../../../utils";

export interface NumericInputLabelProps {
  label?: ReactNode;
  rightLabel?: ReactNode;
  variant: "primary" | "secondary";
  labelClassName?: string;
  rightLabelClassName?: string;
}

export const NumericInputLabel: React.FC<NumericInputLabelProps> = ({
  label,
  rightLabel,
  variant,
  labelClassName,
  rightLabelClassName,
}) => {
  if (!label) return null;

  if (variant === "primary") {
    return (
      <div
        className={cn("ui:flex ui:items-center ui:justify-between", {
          "ui:justify-end": !label,
        })}
      >
        <label className={cn("ui:text-xs ui:text-textPrimary", labelClassName)}>
          {label}
        </label>

        {Boolean(rightLabel) && (
          <span className={cn("ui:text-xs", rightLabelClassName)}>
            {rightLabel}
          </span>
        )}
      </div>
    );
  }

  return (
    <label className={cn("ui:text-xs ui:text-textPrimary", labelClassName)}>
      {label}
    </label>
  );
};
